export const TYPE_MAP_SECUR = {
  2: 21,
  5: 22,
  1: 23,
};
